
// Libraries
var React = require('react');

// Styles
require('./NotificationsCenter.scss');

class NotificationsCenter extends React.Component {
	render() {
		return (
			<div className={"NotificationsCenter"}>

			</div>
		)
	}
}

module.exports = NotificationsCenter;


// WEBPACK FOOTER //
// ./src/components/Notifications/NotificationsCenter.js